import { ProductAction, SET_CAR_INSURANCE_POLICIES, SET_CAR_INSURANCE_POLICIES_ERROR } from '../actions/productsActions';

export type ProductsReduxState = {
  carInsurance: {
    hasError: boolean,
    policies: WebExperienceApiContract.Models.CarinsurancePolicy[],
  },
}

const initialState = {
  carInsurance: {
    hasError: false,
    policies: [],
  },
};

function productsReducer(state = initialState, action: ProductAction) {
  switch (action.type) {
    case SET_CAR_INSURANCE_POLICIES:
      return {
        ...state,
        carInsurance: {
          ...state.carInsurance,
          policies: action.payload || [],
          hasError: false,
        },
      };
    case SET_CAR_INSURANCE_POLICIES_ERROR:
      return {
        ...state,
        carInsurance: {
          ...state.carInsurance,
          policies: [],
          hasError: true,
        },
      }
    default:
      return state;
  }
}

export { initialState, productsReducer };
